import { render } from "./priotagmenu.vue?vue&type=template&id=9d6216ec"
import script from "./priotagmenu.vue?vue&type=script&lang=js"
export * from "./priotagmenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__